import React from "react";
import "./Wedding.css";
import Wedding1st from "./Wedding1st";
import Wedding2nd from "./Wedding2nd";
import Wedding3rd from "./Wedding3rd";
import Wedding4th from "./Wedding4th";
import Wedding5th from "./Wedding5th";

const Wedding = () => {
  return (
    <div>
      <Wedding1st />
      <Wedding2nd />
      <Wedding3rd />
      <Wedding4th />
      <Wedding5th />
    </div>
  );
};

export default Wedding;
